<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="filters.storageRoom.name" placeholder="placeholder.storageRoom" @clear="onStorageRoomClear" @dblclick.native="onStorageRoomSelect"/>
        <vxe-input v-model="filters.zone.name" placeholder="placeholder.zone" @clear="onZoneClear" @dblclick.native="onZoneSelect"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.expConfirm" icon="vxe-icon-upload" status="info" @click="exp"/>
      </template>
      <vxe-table ref="table" :data="data" :export-config="{}" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="zone.name" title="business.label.zone" width="200"/>
        <vxe-column field="owner.name" title="business.label.owner" width="300"/>
        <vxe-column field="total" title="总货位数" width="100"/>
        <vxe-column field="locked" title="锁定货位数" width="100"/>
        <vxe-column field="free" title="空闲货位数" width="100"/>
        <vxe-column field="used" title="占用货位数" width="100"/>
        <vxe-column field="percentage" title="利用率" width="100"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <storage-room-modal ref="storageRoomModal" @change="onStorageRoomChange"/>
    <zone-modal ref="zoneModal" @change="onZoneChange"/>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import ZoneModal from '@/views/modal/ZoneModal.vue'
import { InventoryFactoryView } from '@/api/dto/view/InventoryFactoryView'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import { Zone } from '@/api/dto/common/Zone'

export default {
  name: 'LocationUtilisation',
  components: { ZoneModal, StorageRoomModal },
  data() {
    return {
      loading: false,
      page: 1,
      size: 20,
      contentSize: 0,
      filters: new InventoryFactoryView(),
      data: []
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.refresh()
    },
    onStorageRoomSelect() {
      this.$refs.storageRoomModal.open({ available: true, physical: true })
    },
    onStorageRoomChange(value) {
      this.filters.storageRoom = new StorageRoom(value[0])
      this.refresh()
    },
    onStorageRoomClear() {
      this.filters.storageRoom = new StorageRoom()
      this.refresh()
    },
    onZoneSelect() {
      this.$refs.zoneModal.open({ 'storageRoom.id': this.filters.storageRoom.id })
    },
    onZoneChange(value) {
      this.filters.zone = new Zone(value[0])
      this.refresh()
    },
    onZoneClear() {
      this.filters.zone = new Zone()
      this.refresh()
    },
    refresh() {
      this.loading = true
      const args = {
        'zone.id': this.filters.zone.id,
        'zone.name': this.filters.zone.name,
        'storageRoom.id': this.filters.storageRoom.id,
        'storageRoom.name': this.filters.storageRoom.name
      }
      findAll('locationUtilisationFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    reset() {
      this.filters = new InventoryFactoryView()
      this.data = []
      this.page = 1
    },
    exp() {
      this.$refs.table.openExport()
    }
  }
}
</script>